<template>
  <div class="ml-container">
    <div
      class="ml-item"
      :style="{ width: width + 'px', height: item.height }"
      v-for="(item, index) in mlList"
      :key="index"
    >
      <div v-if="index != mlList.length - 1" class="ml-item-line"></div>
      <div class="text" :class="{ 'text-bold': index == 0 }">{{
        item.text
      }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    width: {
      type: Number,
      default: 20
    },
    /* 容器最大容量 */
    max: {
      type: Number,
      default: 2200,
      // 自定义校验
      validator: function (val) {
        return val % 1 === 0
      }
    },
    /* 刻度尺最大标到的容量 */
    limit: {
      type: Number,
      default: 2200,
      // 自定义校验
      validator: function (val) {
        return val % 1 === 0
      }
    },
    /* 最小容量 */
    min: {
      type: Number,
      default: 0,
      // 自定义校验
      validator: function (val) {
        return val % 1 === 0
      }
    },
    unit: {
      type: String,
      default: 'ML'
    },
    unitNum: {
      type: Number,
      default: 100,
      // 自定义校验
      validator: function (val) {
        return val % 1 === 0
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    mlList() {
      let res = []
      let total = this.data.reduce((pre, cur) => {
        return pre + cur.water_volume
      }, 0)
      this.data.reduce((pre, cur) => {
        let obj = {}
        obj.height = (cur.water_volume / total) * 100 + '%'
        obj.text = total - pre + ' ML'
        res.push(obj)
        return pre + cur.water_volume
      }, 0)
      return res
    }
  },
  created() {}
}
</script>
<style lang="scss" scoped>
.ml-container {
  height: 100%;

  .ml-item {
    position: relative;
  }

  .ml-item-line {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 319px;
    height: 1px;
    background-color: #cbd9ff;
  }

  .text {
    width: 50px;
    white-space: nowrap;
    position: absolute;
    left: 0;
    transform: translate(0%, -110%);
    font-size: 10px;
    font-family: DINCondensed-Bold, DINCondensed;
    color: rgb(140, 147, 152);
    line-height: 12px;
    top: 0;
  }
  .text-bold {
    font-size: 14px;
    line-height: 17px;
    color: rgba(85, 100, 103);
  }
  .item-last {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.6);
  }
}
</style>
